import { requestJson } from "@/shared/services/api";

export interface ContactFormPayload {
  name: string;
  company: string;
  email: string;
  phone: string;
  role: string;
  interest: string;
  message: string;
  /** Honeypot anti-spam: deve chegar vazio. */
  website: string;
}

interface ContactMessageResponse {
  id: string;
  status: "pending" | "sent" | "failed";
  created_at: string;
}

export async function submitContactMessage(
  payload: ContactFormPayload,
  elapsedMs = 0,
): Promise<ContactMessageResponse> {
  const tracking = typeof window !== "undefined" ? window.auLeadTracking?.takeContactContext() : undefined;

  return requestJson<ContactMessageResponse>("/api/public/contact", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      name: payload.name,
      company: payload.company,
      email: payload.email,
      phone: payload.phone,
      role: payload.role,
      interest: payload.interest,
      message: payload.message,
      page: typeof window !== "undefined" ? window.location.pathname : "",
      source: "site",
      website: payload.website,
      elapsed_ms: elapsedMs,
      ...(tracking ? { tracking } : {}),
    }),
  });
}
